
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8 1a5 5 0 0 0-5 5c0 2.808 3.645 6.792 4.286 8.717.237.712.409 1.283.714 1.283s.477-.571.714-1.283C9.355 12.792 13 8.808 13 6a5 5 0 0 0-5-5Zm0 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  